/* ============================================================
   TEABO v5 — moteur des animations d'apparition.

   Reprend le mécanisme de clevrblends.com relevé le 13.08.2026 :
   un IntersectionObserver pose `.is-animated` sur les blocs marqués
   `[data-animate]`, le CSS fait le reste (teabo-v5-anim.css).
   La référence tourne sur GSAP ; ici l'observateur natif suffit —
   son système d'apparition n'est que du CSS, pas de la timeline.

   MARQUAGE AUTOMATIQUE — les 20 bandes v5 ne sont pas modifiées une
   par une. Le script pose lui-même les attributs :

     · `.v5f__c` (le canevas d'une bande) → data-animate
       Ses enfants directs SONT les pièces de la bande — titres,
       textes, images, boutons, tous en position absolue. Elles
       entrent donc ensemble en fondu, la bande se révèle d'un bloc.
       Le fond (`.v5f__bleed`) est un FRÈRE du canevas : il n'est
       jamais animé, un fond qui clignote se remarque.

     · rangées de cartes → data-animate="stagger"
       C'est l'usage qu'en fait la référence : la cascade est faite
       pour des séries d'objets comparables, pas pour un bloc de
       texte. La liste est explicite et se complète à la main.

   CE QUI EST EXCLU, ET POURQUOI
     · `.v5pdpbar` — barre d'achat collante, en position fixe :
       elle doit être là en permanence, pas apparaître au défilement.
     · `.v5hd` / en-tête et pied de page — le chrome ne se révèle pas.
     · Les bandes déjà entrées dans le champ au chargement sont
       révélées immédiatement par l'observateur, sans attendre un
       défilement : le haut de page ne reste jamais blanc.
   ============================================================ */
(function () {
  'use strict';

  var RANGEES = [
    '.v5hbs__rail',      /* cartes best-sellers de l'accueil */
    '.v5htm__rang',      /* cartes de temoignages */
    '.v5club__rail',     /* tuiles du club, fiche produit */
    '.v5km__tuiles',      /* tuiles « moments » de la home */
    '.v5bs__rail',        /* rail Best Sellers */
    '.v5avis__grid',      /* grille d'avis */
    '.v5ugc__row',
    '.v5imm__row',
    '.v5ph__row',
    '.v5pdpvente__piste',
    '.v5pdpfaq__liste',
    '.v5cn__rangee',      /* sous-nav collection */
    '.v5press__track',
    '.v5feat__inner',
    '.v5kit__inner'
  ].join(',');

  var EXCLUS = '.v5pdpbar, .v5hd, .v5foot, [data-no-animate]';

  function marquer() {
    /* Rangées d'abord : si une rangée est aussi un canevas, la
       cascade prime sur le fondu simple. */
    document.querySelectorAll(RANGEES).forEach(function (el) {
      if (el.closest(EXCLUS)) return;
      if (!el.hasAttribute('data-animate')) el.setAttribute('data-animate', 'stagger');
    });
    /* 19.08 — LE CANEVAS ENTIER N'EST PLUS MARQUÉ.
       Relevé sur clevrblends.com, la référence d'origine : elle marque
       21 conteneurs pour 77 enfants au total, et ses conteneurs en
       cascade sont ses RAILS DE CARTES ; les autres n'ont que deux ou
       trois enfants, un titre et un texte. Elle ne révèle jamais une
       section entière.
       Nous faisions l'inverse : `data-animate` sur le canevas de chaque
       bande, soit 105 enfants animés séparément sur une fiche produit,
       dont un conteneur à 35 enfants. D'où la lourdeur au défilement.
       Seules les rangées de cartes sont désormais animées. Les autres
       bandes s'affichent d'emblée, ce qui est aussi le comportement de
       la référence sur ses sections denses. */
  }

  function observer() {
    var blocs = document.querySelectorAll('[data-animate]');
    if (!blocs.length) return;

    if (!('IntersectionObserver' in window)) {
      /* Pas d'observateur : tout est révélé d'emblée. Une page
         invisible serait un bien pire défaut qu'une page sans
         animation. */
      blocs.forEach(function (b) { b.classList.add('is-animated'); });
      return;
    }

    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-animated');
        io.unobserve(e.target);   /* une seule fois : rien ne rejoue au retour */
      });
    }, {
      /* Marge basse négative : la bande se révèle quand elle est
         franchement entrée, pas au premier pixel. */
      rootMargin: '0px 0px -12% 0px',
      threshold: 0
    });

    blocs.forEach(function (b) { io.observe(b); });

    /* FILET, indépendant de l'observateur — le mode de panne de tout ce
       système est une page INVISIBLE, pas une page sans animation : il
       mérite une seconde ligne de défense.
       Un IntersectionObserver peut rester muet dans des cas réels :
       onglet ouvert en arrière-plan (les rappels y sont bridés), moteur
       de défilement en JS qui déplace le contenu sans que le navigateur
       recalcule l'intersection, extension qui neutralise l'API.
       Ce balayage ne s'appuie que sur getBoundingClientRect : si un bloc
       est passé sous le bas de la fenêtre, il est révélé, point.
       Coût nul — throttlé par rAF, et il se débranche tout seul dès que
       tous les blocs sont révélés. */
    var battement = null;
    var reste = Array.prototype.slice.call(blocs);
    var enAttente = false;
    function balayer() {
      enAttente = false;
      reste = reste.filter(function (b) {
        if (b.classList.contains('is-animated')) return false;
        if (b.getBoundingClientRect().top < window.innerHeight) {
          b.classList.add('is-animated');
          io.unobserve(b);
          return false;
        }
        return true;
      });
      if (!reste.length) {
        clearInterval(battement);
        window.removeEventListener('resize', planifier);
        document.removeEventListener('visibilitychange', planifier);
      }
    }
    function planifier() {
      if (enAttente) return;
      enAttente = true;
      requestAnimationFrame(balayer);
    }
    /* ⚠ PERF 14.08 — ce filet ecoutait le DEFILEMENT. A chaque frame il
       mesurait la position de tous les blocs restants (getBoundingClientRect
       force un recalcul de mise en page), en concurrence avec la boucle
       rAF de Lenis. C'etait une source directe de saccades.
       Il sort du chemin de defilement : un battement de 400 ms suffit
       amplement pour un filet de securite, et il s'arrete de lui-meme
       des que tous les blocs sont reveles. */
    battement = setInterval(balayer, 400);
    window.addEventListener('resize', planifier, { passive: true });
    document.addEventListener('visibilitychange', planifier);
    window.addEventListener('load', planifier);
    planifier();
  }

  /* Fondu des images au décodage — équivalent du .lazyloaded de la
     référence, que le thème n'a pas (pas de lazysizes). */
  function imagesEnFondu() {
    document.querySelectorAll('img').forEach(function (img) {
      if (img.closest(EXCLUS)) return;
      if (img.complete && img.naturalWidth > 0) return;  /* déjà là : pas de fondu */
      img.addEventListener('load', function () {
        img.classList.add('v5-img-chargee');
      }, { once: true });
    });
  }

  /* Sortie de page — on éteint le corps avant de naviguer.
     Uniquement sur une vraie navigation interne : ni ancre, ni
     nouvel onglet, ni téléchargement, ni clic modifié. Et JAMAIS
     sur un lien panier, qui n'est plus une navigation mais
     l'ouverture du tiroir (teabo-v5-panier.js). */
  function sortieDePage() {
    document.addEventListener('click', function (ev) {
      if (ev.defaultPrevented) return;
      if (ev.button !== 0 || ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.altKey) return;
      var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
      if (!a || a.target === '_blank' || a.hasAttribute('download')) return;
      var u;
      try { u = new URL(a.href, location.href); } catch (e) { return; }
      if (u.origin !== location.origin) return;
      if (u.pathname === location.pathname && u.hash) return;   /* ancre */
      if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/?$/i.test(u.pathname)) return;
      document.documentElement.classList.add('is-leaving');
    });

    /* Retour arrière depuis le cache : le corps était éteint, on le
       rallume, sinon l'internaute retrouve une page blanche. */
    window.addEventListener('pageshow', function () {
      document.documentElement.classList.remove('is-leaving');
    });
  }

  function demarrer() {
    /* Lève le filet du layout : le moteur est là, .v5-anim peut rester. */
    document.documentElement.dataset.v5Anim = 'ok';
    marquer();
    observer();
    imagesEnFondu();
    sortieDePage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();


/* --- Survol des cartes : lecture de la video ------------------------------
   Les videos de survol (metachamp produit `teabo.video_survol`) sont posees
   SANS autoplay et en preload="none" : rien ne se telecharge tant que le
   pointeur n'est pas entre dans la carte. Un seul couple d'ecouteurs delegues
   pour toute la page, quel que soit le nombre de cartes.
   On sort tout de suite si le pointeur ne sait pas survoler : au doigt,
   .v5cs__survol est deja en display:none (teabo-v5-carte-survol.css). */
(function () {
  if (!window.matchMedia || !matchMedia('(hover: hover)').matches) return;
  var CARTES = '.v5hbs__carte, .v5ce__carte, .v5col__carte';
  function carteDe(n) { return n && n.closest ? n.closest(CARTES) : null; }
  function videoDe(n) {
    var c = carteDe(n);
    return c ? c.querySelector('.v5cs__survol video') : null;
  }
  document.addEventListener('mouseover', function (e) {
    var v = videoDe(e.target);
    if (!v || v.dataset.joue === '1') return;
    v.dataset.joue = '1';
    var p = v.play();
    if (p && p.catch) p.catch(function () {});   /* onglet en arriere-plan, economie d'energie */
  }, true);
  document.addEventListener('mouseout', function (e) {
    var v = videoDe(e.target);
    if (!v) return;
    /* deplacement A L'INTERIEUR de la meme carte : on ne coupe pas */
    if (carteDe(e.relatedTarget) === carteDe(e.target)) return;
    v.dataset.joue = '';
    v.pause();
    try { v.currentTime = 0; } catch (_) {}
  }, true);
})();
